import React from "react";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  fadeVariants,
  slideVariants,
  bounce_right_to_left_variants,
  staticBounceVariants
} from "shared/components/animations";
import ProgressBar from "../components/ProgressBar";
import rank1 from "assets/images/ttl/rank-1.png";
import rank2 from "assets/images/ttl/rank-2.png";
import rank3 from "assets/images/ttl/rank-3.png";

const OverComponent = ({
  users,
  answers,
  isAsker,
  mobile_app,
  over_params,
  toggleModal,
  currentPlayer,
  ttl_users_list,
  correct_answer,
  guesserGuessed,
  ttl_user_score,
  ttl_players_array
}) => {
  const right_text = _.get(over_params, "right_text", "You got it right!");
  const earned_100_text = _.get(
    over_params,
    "earned_100_text",
    "You earned 100 point!"
  );
  const nope_tex = _.get(over_params, "nope_tex", "Nope!");
  const lie_text = _.get(over_params, "lie_text", "The Lie:");
  const modal_button_text = _.get(
    over_params,
    "modal_button_text",
    "My Two Truths and a Lie"
  );

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`ttl-over ${mobile_app ? "mobile-cnt" : "web-cnt"}`}
    >
      {!isAsker && correct_answer === guesserGuessed && (
        <div className="guesser-correct">
          <motion.h2 variants={fadeVariants} className="over-primary-text">
            {right_text}
          </motion.h2>
          <motion.p
            variants={bounce_right_to_left_variants}
            className="ttl-over-result"
          >{`${
            correct_answer === 0 ? "A" : correct_answer === 1 ? "B" : "C"
          }) ${answers[correct_answer]}`}</motion.p>
          <motion.p variants={fadeVariants} className="ttl-primary-text">
            {earned_100_text}
          </motion.p>
        </div>
      )}

      {!isAsker && correct_answer !== guesserGuessed && (
        <div className="guesser-incorrect">
          <motion.h2 variants={fadeVariants} className="over-primary-text">
            {nope_tex}
          </motion.h2>
          <motion.p variants={fadeVariants} className="ttl-primary-text">
            {lie_text}
          </motion.p>
          <motion.p
            variants={bounce_right_to_left_variants}
            className="ttl-over-result"
          >{`${
            correct_answer === 0 ? "A" : correct_answer === 1 ? "B" : "C"
          }) ${answers[correct_answer]}`}</motion.p>
        </div>
      )}

      {/* Liar */}
      {isAsker && (
        <div>
          <motion.p
            variants={fadeVariants}
            className="ttl-primary-text"
          >{`You earned ${ttl_user_score} points!`}</motion.p>
          <motion.div variants={bounce_right_to_left_variants}>
            <ProgressBar
              chunkSize={100 / (users.length - 1)}
              lieCount={ttl_users_list.lie.length}
              truthCount={
                ttl_users_list.truth_1.length + ttl_users_list.truth_2.length
              }
            />
          </motion.div>
        </div>
      )}

      <motion.div
        variants={
          isAsker ? bounce_right_to_left_variants : staticBounceVariants
        }
        className="over-user-profile"
      >
        <div className="over-avatar">
          <img
            alt=""
            className="ttl-over-avatar"
            src={currentPlayer.profile_image}
          />
          <div className="score-div">
            <p className="ttl-badge-score">{ttl_user_score}</p>
          </div>
        </div>
        <p className="over-user-name">{currentPlayer.display_name}</p>
      </motion.div>

      <motion.div
        variants={bounce_right_to_left_variants}
        className="ttl-user-scores"
      >
        <div className={`scores-container ${isAsker ? "asker" : "not-asker"}`}>
          {ttl_players_array?.map((player, index) => (
            <div
              key={index}
              className={`over-user-pill ${
                player.rank === 1
                  ? "color-1"
                  : player.rank === 2
                  ? "color-2"
                  : player.rank === 3 && "color-3"
              } `}
            >
              <div className="over-name-container">
                {player.rank > 3 ? (
                  <div className="over-position-div">{player.rank}</div>
                ) : (
                  <img
                    alt=""
                    className="rank-image"
                    src={
                      player.rank === 1
                        ? rank1
                        : player.rank === 2
                        ? rank2
                        : rank3
                    }
                  />
                )}

                <img
                  alt=""
                  src={player.profile_image}
                  className="user-pill-avatar"
                />
                <span className="scorer-name">{player.display_name}</span>
              </div>
              <span className="scorer-name">{player?.score}</span>
            </div>
          ))}
        </div>
      </motion.div>
      {!isAsker && (
        <motion.div variants={slideVariants} className="bottom-modal">
          <div
            className={`ttl-modal-bottom-container ${
              mobile_app ? "mobile-cnt" : "web-cnt"
            }`}
          >
            <button onClick={toggleModal} className="modal-button">
              {modal_button_text}
            </button>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

export default OverComponent;
